import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
	AUTH_TOKEN,
	AUTH_NOMOR_PENDAFTARAN,
	AUTH_MASUKAN,
	AUTH_NAMA_PENGGUNA,
	FOTO_CMHS,
	AUTH_IS_PPG
} from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import AuthService from 'services/AuthService';
import {USE_API} from "../../configs/EnvironmentConfig";

import {message, notification} from "antd";
import Cookies from 'js-cookie';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: Cookies.get(AUTH_TOKEN) || null,
	nomor_pendaftaran:localStorage.getItem(AUTH_NOMOR_PENDAFTARAN) || null,
	nama_pengguna:localStorage.getItem(AUTH_NAMA_PENGGUNA) || null,
	masukan:localStorage.getItem(AUTH_MASUKAN) || null,
	foto:localStorage.getItem(FOTO_CMHS) || null,
	is_ppg:localStorage.getItem(AUTH_IS_PPG) || false,
	status_aktivasi:false,
	status_reset:false
}


export const signIn = createAsyncThunk('auth/login',async (data, { rejectWithValue }) => {
	const { username, password } = data
	try {
		let response;
		if(USE_API){
			response = await AuthService.login({username, password})
			const token = response.token;

			Cookies.set(AUTH_TOKEN, token, {
				expires: 1, // Cookie expires in 7 days
				secure: true, // Only transmitted over HTTPS
				sameSite: 'strict', // Protect against CSRF
			});

			localStorage.setItem(AUTH_MASUKAN,response.data.masukan);
			localStorage.setItem(AUTH_NOMOR_PENDAFTARAN, response.data.no_pendaftaran);
			localStorage.setItem(AUTH_NAMA_PENGGUNA, response.data.nama);
			localStorage.setItem(FOTO_CMHS, response.data.foto);
			localStorage.setItem(AUTH_IS_PPG,response.data.is_ppg);
		}else{
			response = await AuthService.login({email:username, password})
			const token = response.token;
			localStorage.setItem(AUTH_TOKEN, token);
		}

		return response;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const signUp = createAsyncThunk('auth/register',async (data, { rejectWithValue }) => {
	const { nomor_pendaftaran,tanggal_lahir,email, password,repeat_password } = data

	try {
		const response = await AuthService.register({nomor_pendaftaran,tanggal_lahir,email, password,repeat_password})
		// cek respon dr API
		if(response.success!=true){
			return rejectWithValue(response.message || 'Error')
		}else{
			message.success(response.message,3,function () {
				window.location.href = "auth/login";
			});
		}
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const forgot = createAsyncThunk('auth/forgot',async (data, { rejectWithValue }) => {
	//const { email} = data
	try {
		const response = await AuthService.forgot(data.values)
		return response
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const signOut = createAsyncThunk('auth/logout',async () => {
	const response = await AuthService.logout(localStorage.getItem(AUTH_TOKEN))
	if(response.success!=true){
		notification.error({
			message: 'Perhatian',
			className:"text-danger",
			description:response.message||'error',
			duration:3
		});
	}else {
		Cookies.remove(AUTH_TOKEN);
		localStorage.removeItem(AUTH_NOMOR_PENDAFTARAN);
		localStorage.removeItem(AUTH_NAMA_PENGGUNA);
		localStorage.removeItem(AUTH_MASUKAN);
		localStorage.removeItem(FOTO_CMHS);
		localStorage.removeItem(AUTH_IS_PPG);
		message.success('Anda telah keluar dari aplikasi',3);
	}

	//return response.data
})

export const signInWithGoogle = createAsyncThunk('auth/signInWithGoogle', async (_, { rejectWithValue }) => {
	try {
		const response = await AuthService.loginInOAuth()
		const token = response.data.token;
		localStorage.setItem(AUTH_TOKEN, token);
		return token;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const signInWithFacebook = createAsyncThunk('auth/signInWithFacebook', async (_, { rejectWithValue }) => {
	try {
		const response = await AuthService.loginInOAuth()
		const token = response.data.token;
		localStorage.setItem(AUTH_TOKEN, token);
		return token;
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const aktivasi = createAsyncThunk('auth/aktivasi',async (data, { rejectWithValue }) => {
	const {username,token } = data

	try {
		const response = await AuthService.aktivasi({username,token})
		// cek respon dr API
		if(response.success!=true){
			return rejectWithValue(response.message || 'Error')
		}else{
			return response
		}
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const reset = createAsyncThunk('auth/reset',async (data, { rejectWithValue }) => {
	const {username,token } = data

	try {
		const response = await AuthService.reset({username,token})
		// cek respon dr API
		if(response.success!=true){
			return rejectWithValue(response.message || 'Error')
		}else{
			return response
		}
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const proses_reset = createAsyncThunk('auth/proses_reset',async (data, { rejectWithValue }) => {
	const {username,token,password,repeat_password } = data

	try {
		const response = await AuthService.proses_reset({username,token,password,repeat_password})
		// cek respon dr API
		if(response.success!=true){
			return rejectWithValue(response.message || 'Error')
		}else{
			return response
		}
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})


export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			state.loading = false
			state.redirect = '/'
			state.token = action.payload.token
			state.nomor_pendaftaran=action.payload.data.no_pendaftaran
			state.nama_pengguna=action.payload.data.nama
			state.masukan=action.payload.data.masukan
			state.is_ppg=action.payload.data.is_ppg
		},
		showAuthMessage: (state, action) => {
			state.message = action.payload
			state.showMessage = true
			state.loading = false
		},
		hideAuthMessage: (state) => {
			state.message = ''
			state.showMessage = false
		},
		signOutSuccess: (state) => {
			state.loading = false
			state.token = null
			state.redirect = '/'
            state.token = null
            state.nomor_pendaftaran= null
            state.nama_pengguna=null
            state.masukan=null
            state.is_ppg=false
		},
		showLoading: (state) => {
			state.loading = true
		},
		signInSuccess: (state, action) => {
			state.loading = false
			state.token = action.payload.token
			state.nomor_pendaftaran=action.payload.data.no_pendaftaran
			state.nama_pengguna=action.payload.data.nama
			state.masukan=action.payload.data.masukan
			state.foto=action.payload.data.foto
			state.is_ppg=action.payload.data.is_ppg
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(signIn.pending, (state) => {
				state.loading = true
			})
			.addCase(signIn.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload.token
				state.nomor_pendaftaran=action.payload.data.no_pendaftaran
				state.nama_pengguna=action.payload.data.nama
				state.masukan=action.payload.data.masukan
				state.is_ppg=action.payload.data.is_ppg
			})
			.addCase(signIn.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signOut.fulfilled, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
                state.token = null
                state.nomor_pendaftaran= null
                state.nama_pengguna=null
                state.masukan=null
                state.is_ppg=false
			})
			.addCase(signOut.rejected, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signUp.pending, (state) => {
				state.loading = true
			})
			.addCase(signUp.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = ''
				state.token = action.payload
			})
			.addCase(signUp.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signInWithGoogle.pending, (state) => {
				state.loading = true
			})
			.addCase(signInWithGoogle.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signInWithGoogle.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signInWithFacebook.pending, (state) => {
				state.loading = true
			})
			.addCase(signInWithFacebook.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signInWithFacebook.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(aktivasi.pending, (state) => {
				state.loading = true
			})
			.addCase(aktivasi.fulfilled, (state, action) => {
				state.loading = false
				state.status_aktivasi = action.payload.success
				state.message = action.payload.message
			})
			.addCase(aktivasi.rejected, (state, action) => {
				state.status_aktivasi = action.payload.success
				state.loading = false
				state.message = action.payload.message
			})
			.addCase(reset.pending, (state) => {
				state.loading = true
			})
			.addCase(reset.fulfilled, (state, action) => {
				state.loading = false
				state.status_reset = action.payload.success
				state.message = action.payload.message
			})
			.addCase(reset.rejected, (state, action) => {
				state.status_reset = action.payload.success
				state.loading = false
				state.message = action.payload.message
			})
	},
})

export const {
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = authSlice.actions

export default authSlice.reducer
